(() => {
  const formatMoney = (cents, format) => {
    const value = Number(cents) || 0;
    const fixed = (decimals, thousands, decimal) => {
      const [whole, fraction] = (value / 100).toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
    };
    return (format || '€{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: fixed(2, ',', '.'),
      amount_no_decimals: fixed(0, ',', '.'),
      amount_with_comma_separator: fixed(2, '.', ','),
      amount_no_decimals_with_comma_separator: fixed(0, '.', ','),
      amount_with_apostrophe_separator: fixed(2, "'", '.')
    }[key] ?? fixed(2, ',', '.')));
  };
  window.RosviaMoney = window.RosviaMoney || formatMoney;

  const initProduct = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const format = root.dataset.moneyFormat;
    const gallery = root.querySelector('[data-product-gallery]');
    const mainImage = gallery?.querySelector('.product-gallery__image');
    const thumbs = gallery ? [...gallery.querySelectorAll('[data-gallery-thumb]')] : [];
    const dots = gallery ? [...gallery.querySelectorAll('.product-gallery__dots span')] : [];
    let index = 0;

    const show = next => {
      if (!thumbs.length || !mainImage) return;
      index = (next + thumbs.length) % thumbs.length;
      const thumb = thumbs[index];
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = thumb.dataset.gallerySrc;
      mainImage.alt = thumb.dataset.galleryAlt;
      thumbs.forEach((item, i) => { item.classList.toggle('is-active', i === index); item.setAttribute('aria-pressed', String(i === index)); });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };

    gallery?.addEventListener('click', event => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) show(thumbs.indexOf(thumb));
      const step = event.target.closest('[data-gallery-step]');
      if (step) show(index + Number(step.dataset.galleryStep));
      if (event.target.closest('[data-gallery-zoom]')) {
        const lightbox = root.querySelector('[data-gallery-lightbox]');
        if (!lightbox) return;
        lightbox.querySelector('[data-lightbox-image]').src = (thumbs[index]?.dataset.gallerySrc || mainImage.currentSrc || mainImage.src).replace(/width=\d+/, 'width=1600');
        lightbox.showModal();
      }
    });
    const lightbox = root.querySelector('[data-gallery-lightbox]');
    lightbox?.addEventListener('click', event => { if (event.target === lightbox || event.target.closest('[data-lightbox-close]')) lightbox.close(); });

    let touchStart = null;
    const mainArea = gallery?.querySelector('[data-gallery-main]');
    mainArea?.addEventListener('touchstart', event => { touchStart = event.touches[0].clientX; }, { passive: true });
    mainArea?.addEventListener('touchend', event => {
      if (touchStart === null) return;
      const delta = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 40) show(index + (delta < 0 ? 1 : -1));
      touchStart = null;
    });

    const form = root.querySelector('[data-product-form]');
    const quantity = root.querySelector('[data-product-quantity]');
    const select = root.querySelector('[data-product-variant]');
    const rows = [...root.querySelectorAll('[data-tier-min]')];
    const addButton = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-label]');
    const stickyBar = root.querySelector('[data-sticky-bar]');

    // Shopify takes a percentage code off each unit and rounds that saving down to the cent (as brand-builder.js does).
    const discounted = (unitPrice, percent) => unitPrice - Math.floor(unitPrice * percent / 100);

    const sync = () => {
      const option = select?.selectedOptions[0];
      const unitPrice = Number(option ? option.dataset.price : root.dataset.unitPrice);
      const count = Math.max(Number(quantity.min) || 1, Number(quantity.value) || 1);
      let percent = 0;
      rows.forEach(row => {
        const active = count >= Number(row.dataset.tierMin) && count <= Number(row.dataset.tierMax);
        row.classList.toggle('is-active', active);
        if (active) percent = Number(row.dataset.tierPercent) || 0;
        // Keep row prices right when the variant (and so the unit price) changes.
        const rowPercent = Number(row.dataset.tierPercent) || 0;
        const unitCell = row.querySelector('[data-tier-unit]');
        if (unitCell) unitCell.textContent = formatMoney(discounted(unitPrice, rowPercent), format);
        const baseCell = row.querySelector('[data-tier-base]');
        if (baseCell) baseCell.textContent = formatMoney(unitPrice, format);
        const totalCell = row.querySelector('[data-tier-total]');
        if (totalCell) totalCell.textContent = formatMoney(discounted(unitPrice, rowPercent) * Number(row.dataset.tierMin), format);
      });
      root.querySelector('[data-line-price]').textContent = formatMoney(discounted(unitPrice, percent) * count, format);
      if (option) {
        const available = option.dataset.available === 'true';
        root.querySelector('[data-variant-price]').textContent = option.dataset.money;
        const compare = root.querySelector('[data-variant-compare]');
        compare.hidden = !option.dataset.compare;
        compare.textContent = option.dataset.compare;
        addButton.disabled = !available;
        addLabel.textContent = available ? addLabel.dataset.labelAdd : addLabel.dataset.labelSoldOut;
        if (stickyBar) {
          stickyBar.querySelector('[data-sticky-price]').textContent = option.dataset.money;
          stickyBar.querySelector('[data-sticky-add]').disabled = !available;
          stickyBar.querySelector('[data-sticky-label]').textContent = addLabel.textContent;
        }
      }
    };

    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
      quantity.value = quantity.min;
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState(null, '', url);
      sync();
    });
    quantity?.addEventListener('change', sync);
    quantity?.addEventListener('input', sync);
    rows.forEach(row => row.addEventListener('click', () => { quantity.value = row.dataset.tierMin; sync(); }));
    if (quantity) sync();

    if (stickyBar && form) {
      let frame = 0;
      const footer = document.querySelector('.site-footer, footer');
      // The bar stands in for the main Add to Cart button whenever that button is off screen, above or below the
      // viewport (on phones it starts below the gallery), and steps aside while it or the footer is in view.
      // The pinned header (--header-pinned-height, header.js) counts as off screen.
      const update = () => {
        frame = 0;
        const button = (addButton || form).getBoundingClientRect();
        const top = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
        const buttonInView = button.bottom > top && button.top < innerHeight;
        const atFooter = footer ? footer.getBoundingClientRect().top < innerHeight : false;
        stickyBar.hidden = buttonInView || atFooter;
      };
      addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
      addEventListener('resize', update);
      update();
      stickyBar.querySelector('[data-sticky-add]').addEventListener('click', () => form.requestSubmit());
    }
  };

  const initRecommendations = async container => {
    if (container.dataset.loaded || !container.dataset.url) return;
    container.dataset.loaded = 'true';
    try {
      const response = await fetch(container.dataset.url);
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('[data-product-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        container.innerHTML = fresh.innerHTML;
        document.dispatchEvent(new CustomEvent('products:rendered'));
      }
    } catch {}
  };

  const scrollCarousel = event => {
    const button = event.target.closest('[data-carousel-step]');
    const scroller = button?.closest('.product-related__carousel')?.querySelector('[data-product-scroller]');
    if (scroller) scroller.scrollBy({ left: Number(button.dataset.carouselStep) * scroller.clientWidth * .8, behavior: 'smooth' });
  };

  const init = () => {
    document.querySelectorAll('[data-main-product]').forEach(initProduct);
    document.querySelectorAll('[data-product-recommendations]').forEach(initRecommendations);
  };
  document.addEventListener('click', scrollCarousel);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
